(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sola-readmore"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sola-readmore')) {
    customElements.define(
      'sola-readmore',
      class SolaReadMore extends HTMLElement {
        connectedCallback() {
          this.body = this.querySelector('.sola-readmore__body');
          this.toggle = this.querySelector('.sola-readmore__toggle');
          if (!this.body || !this.toggle) return;

          this.onToggleClick = this.onToggleClick.bind(this);
          this.measure = this.measure.bind(this);

          this.toggle.addEventListener('click', this.onToggleClick);
          this.setAttribute('data-ready', '');

          // Re-measure on reflow (viewport changes, font swap, variant switches).
          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this.body);

          // Inside a collapsed accordion the body has no height yet, so wait
          // until the surrounding <details> opens before deciding anything.
          this.details = this.closest('details');
          if (this.details) this.details.addEventListener('toggle', this.measure);

          this.measure();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.toggle?.removeEventListener('click', this.onToggleClick);
          this.details?.removeEventListener('toggle', this.measure);
        }

        measure() {
          // Not laid out yet (hidden tab, closed accordion) — decide later.
          if (this.body.clientHeight === 0) return;
          if (this.hasAttribute('data-open')) return;

          const overflows = this.body.scrollHeight > this.body.clientHeight + 1;
          this.toggle.hidden = !overflows;
          this.toggleAttribute('data-clamped', overflows);
        }

        onToggleClick() {
          const open = this.toggleAttribute('data-open');
          this.toggle.setAttribute('aria-expanded', String(open));
          this.querySelector('[data-readmore-more]').hidden = open;
          this.querySelector('[data-readmore-less]').hidden = !open;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
